import { render, staticRenderFns } from "./ConfirmDialogText.vue?vue&type=template&id=00c81e3e"
import script from "./ConfirmDialogText.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports